import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {

  /*-------------------------------------------------------------------------------
    共通・初期化
  --------------------------------------------------------------------------------*/

  pageLoading();
  modalImage();
  
  // ScrollTriggerプラグインを登録
  gsap.registerPlugin(ScrollTrigger);


  /*-------------------------------------------------------------------------------
    MVオープニングアニメーション（初回訪問時のみ）- GSAP版
  --------------------------------------------------------------------------------*/
  const initMVAnimation = () => {
    // セッションストレージで初回訪問チェック
    const hasVisited = sessionStorage.getItem('hasVisitedMV');
    
    if (!hasVisited && document.querySelector('.mainimg_wrapper')) {
      sessionStorage.setItem('hasVisitedMV', 'true');
      
      // 必要な要素を取得
      const wrapper = document.querySelector('.mainimg_wrapper');
      const img = wrapper.querySelector('.mainimg img');
      const titleEl = document.querySelector('.main_ttl');
      const copyEl = document.querySelector('.main_copy');
      const header = document.querySelector('.header');
      
      if (!wrapper || !img || !titleEl || !copyEl || !header) return;
      
      // 青マスク要素を動的に生成
      const maskTop = document.createElement('div');
      const maskBottom = document.createElement('div');
      maskTop.className = 'mv-mask mv-mask-top';
      maskBottom.className = 'mv-mask mv-mask-bottom';
      wrapper.appendChild(maskTop);
      wrapper.appendChild(maskBottom);
      
      // タイトルの元のHTMLを保存
      const originalTitleHTML = titleEl.innerHTML;
      
      // タイトルを一文字ずつspanで囲む（br要素を保持）
      const chars = [];
      const nodes = Array.from(titleEl.childNodes);
      titleEl.innerHTML = '';
      
      nodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          Array.from(text).forEach(char => {
            const span = document.createElement('span');
            span.style.display = 'inline-block';
            if (char === ' ' || char === '\u3000') {
              span.innerHTML = '&nbsp;';
            } else {
              span.textContent = char;
            }
            titleEl.appendChild(span);
            chars.push(span);
          });
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          titleEl.appendChild(node.cloneNode(true));
        }
      });
      
      // GSAPタイムラインを作成
      const tl = gsap.timeline({
        onComplete: () => {
          // アニメーション完了後、元の状態に戻す
          maskTop.remove();
          maskBottom.remove();
          titleEl.innerHTML = originalTitleHTML;
        }
      });
      
      // 初期状態を設定
      gsap.set(maskTop, { yPercent: 0 });
      gsap.set(maskBottom, { yPercent: 0 });
      gsap.set(img, { scale: 1.2, filter: 'brightness(0.7) blur(20px)' });
      gsap.set(chars, { opacity: 0, y: -30 });
      gsap.set(copyEl, { opacity: 0 });
      gsap.set(header, { y: -100, opacity: 0 });
      
      // アニメーションシーケンス
      tl
        // 0.5秒待機
        .to({}, { duration: 0.5 })
        // 画像のボケ→シャープ、拡大→縮小（2秒）
        .to(img, {
          scale: 1,
          filter: 'brightness(0.7) blur(0px)',
          duration: 2,
          ease: 'power2.out'
        }, 0.5)
        // 青マスクが上下に分かれて消える（1.2秒）
        .to(maskTop, {
          yPercent: -100,
          duration: 1.2,
          ease: 'power2.inOut'
        }, 0.8)
        .to(maskBottom, {
          yPercent: 100,
          duration: 1.2,
          ease: 'power2.inOut'
        }, 0.8)
        // タイトルの一文字ずつ表示（各0.1秒間隔でスタガー）
        .to(chars, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out'
        }, 2.0)
        // コピーのフェードイン
        .to(copyEl, {
          opacity: 1,
          duration: 1,
          ease: 'power2.out'
        }, `-=0.3`)
        // ヘッダーナビの降下
        .to(header, {
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: 'power2.out'
        }, `-=0.5`);
    }
  };
  
  initMVAnimation();


  /*-------------------------------------------------------------------------------
    お問い合わせ用バリデーション
  --------------------------------------------------------------------------------*/
  // ページ内に #form-confirm という要素が存在する場合のみバリデーション実行
  if (document.querySelector('#form-confirm')) {
    topValidation();
    
    // フォームの一番上にスムーズスクロールする関数
    const scrollToFormTop = () => {
      const formWrapper = document.querySelector('.contact_form_unit_wrapper');
      if (formWrapper) {
        const header = document.querySelector('.header.fixed_hd') || document.querySelector('.header');
        const headerHeight = header ? header.offsetHeight : 0;
        const offset = 20;
        const targetPosition = formWrapper.getBoundingClientRect().top + window.pageYOffset - headerHeight - offset;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    };
    
    // MutationObserverで#form-confirmと#form-inputの表示切り替えのみを監視
    const confirmElement = document.querySelector('#form-confirm');
    const inputElement = document.querySelector('#form-input');
    
    if (confirmElement && inputElement) {
      let lastConfirmDisplay = getComputedStyle(confirmElement).display;
      let lastInputDisplay = getComputedStyle(inputElement).display;
      
      // #form-confirmの表示変更を監視
      const confirmObserver = new MutationObserver(() => {
        const currentDisplay = getComputedStyle(confirmElement).display;
        if (lastConfirmDisplay === 'none' && currentDisplay !== 'none') {
          setTimeout(scrollToFormTop, 100);
        }
        lastConfirmDisplay = currentDisplay;
      });
      
      confirmObserver.observe(confirmElement, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      
      // #form-inputの表示変更を監視
      const inputObserver = new MutationObserver(() => {
        const currentDisplay = getComputedStyle(inputElement).display;
        if (lastInputDisplay === 'none' && currentDisplay !== 'none') {
          setTimeout(scrollToFormTop, 100);
        }
        lastInputDisplay = currentDisplay;
      });
      
      inputObserver.observe(inputElement, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  }

  /*-------------------------------------------------------------------------------
    ハンバーガーナビゲーション
  --------------------------------------------------------------------------------*/
  const hamburger = document.querySelector('.menu-trigger');
  const nav = document.querySelector('.nav');
  if (hamburger && nav) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('js-open');
      nav.classList.toggle('js-open');
    });

    const navLinks = nav.querySelectorAll('a');
    navLinks.forEach(link => {
      link.addEventListener('click', function () {
        hamburger.classList.remove('js-open');
        nav.classList.remove('js-open');
      });
    });
  }

  /*-------------------------------------------------------------------------------
    .fadeup要素のスクロールアニメーション
  --------------------------------------------------------------------------------*/
  const fadeupElements = document.querySelectorAll('.fadeup');
  fadeupElements.forEach((el) => {
    gsap.fromTo(el,
      {
        y: 50,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );
  });

  // .fadeup-listの子要素を左から順番にアニメーション
  const fadeupLists = document.querySelectorAll('.fadeup-list');
  fadeupLists.forEach((list) => {
    const children = list.children;
    gsap.fromTo(children,
      {
        y: 50,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: list,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );
  });

  /*-------------------------------------------------------------------------------
    ページ内スムーススクロール
  --------------------------------------------------------------------------------*/
  const links = document.querySelectorAll('a[href*="#"]');
  const header = document.querySelector('.header');
  
  links.forEach(link => {
    link.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (!href || !href.includes('#')) return;
      
      e.preventDefault();
      
      const hash = href.split('#')[1];
      if (!hash || hash === 'home') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      
      const target = document.getElementById(hash);
      if (target) {
        const top = target.offsetTop - header.offsetHeight;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /*-------------------------------------------------------------------------------
    ナビゲーションカレント表示
  --------------------------------------------------------------------------------*/
  const navLinks = document.querySelectorAll('.hd_nav a');
  const sections = document.querySelectorAll('section[id]');
  
  function updateNav() {
    const scrollPos = window.scrollY + header.offsetHeight + 100;
    
    if (window.scrollY < 100) {
      navLinks.forEach(link => {
        const href = link.getAttribute('href');
        link.classList.toggle('is-active', href.includes('#home') || href.endsWith('#'));
      });
      return;
    }
    
    sections.forEach(section => {
      const top = section.offsetTop;
      const bottom = top + section.offsetHeight;
      const id = section.getAttribute('id');
      
      if (scrollPos >= top && scrollPos < bottom) {
        navLinks.forEach(link => {
          const href = link.getAttribute('href');
          link.classList.toggle('is-active', href.includes('#' + id));
        });
      }
    });
  }
  
  window.addEventListener('scroll', updateNav);
  updateNav();

});
